import type { CompetitionDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getCompetitionDetails(competitionId: string): Promise<CompetitionDetailed> {
  return requestApiJsonOrThrow<CompetitionDetailed>(`admin/competitions/${competitionId}`)
}

export const competitionDetailsQuery = (competitionId: string) => ({
  queryKey: ['competition', competitionId],
  queryFn: () => getCompetitionDetails(competitionId),
})
